var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from '@max/max';
import { getUserInfo, login } from '@nibfe/mkt-user-api';
export const useUserInfo = (needLogin = false) => {
    const [userInfo, setUserInfo] = useState({
        token: '',
        avatarURL: '',
        uuid: '',
        userId: '',
        userName: '',
        done: false
    });
    useEffect(() => {
        // 获取用户信息
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield getUserInfo();
            if (result.userId) {
                setUserInfo(Object.assign(Object.assign({}, result), { done: true }));
            }
            else if (needLogin) {
                yield login();
            }
            else {
                setUserInfo(Object.assign(Object.assign({}, userInfo), { done: true }));
            }
        }))();
    }, []);
    return {
        userInfo
    };
};
